export const privacyStylesheet = String.raw`
  .privacy-page {
    display: grid;
    gap: var(--herefor-space-4);
    max-inline-size: 48rem;
  }

  .privacy-page__introduction {
    margin-block: 0 var(--herefor-space-2);
    color: var(--herefor-color-text-muted);
    font-size: var(--herefor-font-size-lg);
  }

  .privacy-page p {
    max-inline-size: 68ch;
  }

  .privacy-settings-link {
    margin-block-start: var(--herefor-space-5);
  }
`;
